const generateFileName = name => {
  const date = new Date();

  return `${name}_${date.getFullYear()}_${date.getMonth() +
    1}_${date.getDate()}`;
};

export { generateFileName };
